<template>
  <div class="banner">
    <div class="banner-box">
      <div class="banner-background">
        <img src="@/assets/companyprofilepic/banner.jpg" />
      </div>
      <div class="top"  data-aos="fade-up">
        <div class="machine">
          <img src="@/assets/companyprofilepic/bannermachine.png" />
        </div>
        <div class="banner-text">
          <div class="banner-h1">
            <h1>{{ $t('banner1') }}</h1>
          </div>
          <div class="banner-h1">
            <h1>{{ $t('banner2') }}</h1>
          </div>
          <div class="banner-h2">
            <h2>{{ $t('banner3') }}</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AOS from 'aos';

export default {
  name: "Banner",
  mounted() {
    AOS.refresh();
  },
};
</script>

<style scoped>
.banner-box {
  position: relative;
  width: 100%;
}

.banner-background {
  width: 100%;
  height: auto;
  position: relative;
}

.banner-background img {
  width: 100%;
  height: auto;
}

.top {
  position: absolute;
  top: -25%;
  left: 30%;
  transform: translate(-50%, -50%); 
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 30px;
  color: #fff;
  text-align: center;
  
}

.machine {
  width: 13vw;
}

.machine img {
  width: 100%;
  height: auto;
}

.banner-text {
  display: flex;
  flex-direction: column;
  justify-content: center; 
  align-items: center;
  width: 25vw; 
  height: 100%; 
  text-align: center; 
}

.banner-text h1, h2 {
  margin: 0;
}

.banner-h1 {
  font-size: .8vw;
  letter-spacing: 0.2em;
}

.banner-h2 {
  display: inline-block;
  border: 1px solid #fff;
  padding: .1vw;
  margin-top: .1vw;
  font-weight: normal;
  font-size: .6vw;
  
}

.banner-text .banner-h1:first-child {
  font-size: .6vw;
  font-weight: normal;
  letter-spacing: normal;
}

</style>



// WEBPACK FOOTER //
// src/views/home/products/Banner.vue